export default [
  {
    parentField: undefined,
    currentField: 'delivery_type', 
  },
  {
    parentField: undefined,
    currentField: 'pickup_date', 
  }
]